// LoreLogo.jsx — logo LORE con semicerchi arancio/blu
// Uso: <LoreLogo size={56} /> oppure <LoreLogo size={120} />

export default function LoreLogo({ size = 56 }) {
  const uid = `lore-${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none">
      <defs>
        <clipPath id={`top-${uid}`}><rect x="0" y="0" width="200" height="100" /></clipPath>
        <clipPath id={`bot-${uid}`}><rect x="0" y="100" width="200" height="100" /></clipPath>
      </defs>
      {/* Semicerchio superiore — arancione */}
      <circle cx="100" cy="100" r="90" stroke="#FF9C00" strokeWidth="4.5" fill="none" clipPath={`url(#top-${uid})`} />
      <circle cx="100" cy="100" r="75" stroke="#FF9C00" strokeWidth="2.5" fill="none" clipPath={`url(#top-${uid})`} opacity="0.6" />
      <circle cx="100" cy="100" r="60" stroke="#FF9C00" strokeWidth="1.5" fill="none" clipPath={`url(#top-${uid})`} opacity="0.3" />
      {/* Semicerchio inferiore — blu chiaro */}
      <circle cx="100" cy="100" r="90" stroke="#4A7BB7" strokeWidth="4.5" fill="none" clipPath={`url(#bot-${uid})`} />
      <circle cx="100" cy="100" r="75" stroke="#4A7BB7" strokeWidth="2.5" fill="none" clipPath={`url(#bot-${uid})`} opacity="0.6" />
      <circle cx="100" cy="100" r="60" stroke="#4A7BB7" strokeWidth="1.5" fill="none" clipPath={`url(#bot-${uid})`} opacity="0.3" />
      {/* Testo */}
      <text
        x="100" y="100"
        fontFamily="Arial, sans-serif"
        fontSize="38" fontWeight="700"
        fill="#FFFFFF"
        textAnchor="middle"
        dominantBaseline="central"
        letterSpacing="4"
      >LORE</text>
    </svg>
  );
}
